import { ReactNode, useEffect } from "react";
import { ThemeContext } from "./ThemeContext";
import { injectThemeColors } from "@/theme/utils/injectThemeColors";
import { injectTypography } from "@/theme/utils/injectTypography";
import { injectSpacing } from "@/theme/utils/injectSpacing";
import { injectBreakpoints } from "@/theme/utils/injectBreakpoints";

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const theme = "light";
  const toggleTheme = () => {
    // Implement theme toggle
  };

  useEffect(() => {
    // Inject theme tokens as CSS variables
    injectThemeColors();
    injectTypography();
    injectSpacing();
    injectBreakpoints();
  }, []);

  return <ThemeContext.Provider value={{ theme, toggleTheme }}>{children}</ThemeContext.Provider>;
};
